
import { India, USA, UAE, Nepal, Malaysia } from "./Constants";
import { getBranch } from '../data/localSettingsActions';
import Utils from './Utils';
export default class BranchHelper {
    static IsIndiaBranch(branch) {
        var branchCountryCode = "";
        if (Utils.IsNullOrEmptyObject(branch) === true) {
            var tempBranch = getBranch();
            if (Utils.IsNullOrEmptyObject(tempBranch) !== true)
                branchCountryCode = tempBranch.countryCode;
        }
        else
            branchCountryCode = branch.countryCode;
        return branchCountryCode == India.Code;
    }

    static IsUSABranch(branch) {
        var branchCountryCode = "";
        if (Utils.IsNullOrEmptyObject(branch) === true) {
            var tempBranch = getBranch();
            if (Utils.IsNullOrEmptyObject(tempBranch) !== true)
                branchCountryCode = tempBranch.countryCode;
        }
        else
            branchCountryCode = branch.countryCode;
        return branchCountryCode == USA.Code;
    }

    static IsUAEBranch(branch) {
        var branchCountryCode = "";
        if (Utils.IsNullOrEmptyObject(branch) === true) {
            var tempBranch = getBranch();
            if (Utils.IsNullOrEmptyObject(tempBranch) !== true)
                branchCountryCode = tempBranch.countryCode;
        }
        else
            branchCountryCode = branch.countryCode;
        return branchCountryCode == UAE.Code;
    }

    static IsNepalBranch(branch) {
        var branchCountryCode = "";
        if (Utils.IsNullOrEmptyObject(branch) === true) {
            var tempBranch = getBranch();
            if (Utils.IsNullOrEmptyObject(tempBranch) !== true)
                branchCountryCode = tempBranch.countryCode;
        }
        else
            branchCountryCode = branch.countryCode;
        return branchCountryCode == Nepal.Code;
    }

    static IsMalaysiaBranch(branch) {
        var branchCountryCode = "";
        if (Utils.IsNullOrEmptyObject(branch) === true) {
            var tempBranch = getBranch();
            if (Utils.IsNullOrEmptyObject(tempBranch) !== true)
                branchCountryCode = tempBranch.countryCode;
        }
        else
            branchCountryCode = branch.countryCode;
        return branchCountryCode == Malaysia.Code;
    }
}